import detailApiCall from './detail';
import editApiCall from './edit';
import listApiCall from './list';
import syncApiCall from './sync';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  edit: editApiCall,
  sync: syncApiCall,
};

export default ApiCall;
